import React, { useEffect, useRef, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Theme } from '@mui/material';
import "../css/receivefunds.css"
import { Scrollbars } from 'react-custom-scrollbars';
import AuthCode, { AuthCodeRef } from 'react-auth-code-input';

const useStyles = makeStyles((theme: Theme)=>{
    return {
        navIcon: {
            color: '#999 !important',
            fontSize: '1.7rem !important',
            fontWeight: '900 !important'
        },
        logo: {
            transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
            margin:'0 auto'
        },
        logoHolder: {
          width: '100%',
          display: 'flex',
          justifyContent:'center',
          alignItems: 'center'
        },
        paragraph: {
          lineHeight: 1.6,
          color: '#555',
          fontSize: '0.978rem',
          fontStyle: 'normal',
          textAlign: 'left',
          fontWeight: '400',
          marginBottom: '30px'
      },
      footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '1rem',
        [theme.breakpoints.down('md')]: {
          padding: '0rem',
        },
      },
      linkButton: {
        color: '#fff !important',
        backgroundColor: '#5d307f',
        borderColor: '#5d307f',
        marginLeft: '10px',
        display: 'inline-block',
        fontWeight: 400,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid transparent',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '0.25rem',
        textDecoration: 'none',
        transition: 'all 0.15s ease-in-out',

        "&:hover": {
          color: '#000 !important',
          backgroundColor: '#e37927',
          borderColor: '#e37927',
        },

        [theme.breakpoints.down('sm')]: {
          marginLeft: '0',
          marginTop: '5px',
          display: 'block'
        },
      },
      asideInner: {
        padding: '1rem',
        width: '100%',
        height: '100%',

        [theme.breakpoints.down('md')]: {
          padding: '1rem',
        },
      }
    }
})


interface Props{
    handleEnterPinClose: ()=> void
    lunchSomethingWrong: ()=> void
}

const EnterPin: React.FC<Props> = ({handleEnterPinClose, lunchSomethingWrong}) => {
  const classes = useStyles()
  const authCodeRef = useRef<AuthCodeRef>(null);

  const [result, setResult] = useState('');
  const handleOnChange = (res: string) => {
    setResult(res);
  };


 const cancelTransaction =()=>{
    handleEnterPinClose()
    authCodeRef.current?.clear();
 }
 const handleProceed =()=>{
  lunchSomethingWrong()
 }

  return (
    <div id='sidebar-wrapper-enter-pin' className='sidebar-wrapper-receive-funds'>
        
        <div className='sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable modal-dialog-420-important'>
            <aside className='sidebar-receive-funds-beneficiaries' style={{padding: '0 0.6rem'}}>
                
            <div className='funds-beneficiaries-header'>
              <h6 className="funds-ben-header-h6">Enter Pin</h6>
              <button type="button" className="btn-beneficiaries-funds close" onClick={cancelTransaction}>×</button>
            </div>


            <div className='funds-beneficiaries-body' style={{paddingBottom: '0'}}>
              <div style={{margin: '0rem 0'}}>




                <div style={{marginBottom: '3rem'}}>
                  <div style={{position: 'relative', overflow: 'hidden'}}>
                    
                        <div className='enter-pin-input-body'>

                            <label className="custom-large-badge-limit-trasacation-label" style={{padding: '1rem 0'}}>Please Enter Your Transaction Pin To Continue</label>

                            <AuthCode ref={authCodeRef} containerClassName='pin-input' length={4} onChange={handleOnChange} />
                        </div>
                        
                        <div className="limit-transaction-past-wrapper">
                            <button type="button" className="btn groom-panel-2-content-text-btn-limit-transaction1-enter-pin" onClick={cancelTransaction}>Cancel</button>
                            <button type="button" className="btn groom-panel-2-content-text-btn-limit-transaction2" onClick={handleProceed}>Proceed</button>
                        </div>
                  </div>
                </div>
              </div>
            </div>

                
            </aside>
        </div>
    </div>
  )
}

export default EnterPin
